import React from 'react';
import Modal from '../../components/Modal/Modal';
import { useSelector, useDispatch } from 'react-redux';
import {
    setServiceNavigatorCurrentService,
    setServiceNavigatorCurrentButton, setServiceNavigatorNebenFabrikat,
    setServiceNavigatorCurrentStep, 
} from '../../../modules/actions/standort/service/serviceNavigator';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { useStandortHistory } from '../../components/VHost/StandortHistory';

function ServicenavigatorServicesList({ Services }) {
    const dispatch = useDispatch(); 
    const history = useStandortHistory();
    const shopBrand = useSelector(state => state.standort);
    const standortUrl = useSelector(standortUrlSelector);
    const vehiclePreSelected = useSelector(state => state.serviceNavigator.data?.VehiclePreSelected);
    const hauptFabrikat = shopBrand[standortUrl]['markenStandort']['data']['hauptFabrikat'];
    const currentStep = useSelector(state => state.serviceNavigator.data?.CurrentStep ?? 1);

    const [selectedService, setSelectedService] = React.useState({});
    const [open, setOpen] = React.useState(false);
    const [currentModal, setCurrentModal] = React.useState({});

    let serviceNr = 0;

    const handleClick = (e) => {
        let service = document.querySelectorAll('[data-value]');
        let currentElement = document.querySelector(`[data-index="${serviceNr}"]`);
        currentElement.classList.remove("active");
        if (e.currentTarget.className.split(" ").includes("next")) {
            if (service.length - 1 === serviceNr) {
                serviceNr = 0
            } else {
                serviceNr += 1
            }
        } else {
            if (serviceNr === 0) {
                serviceNr = service.length - 1
            } else {
                serviceNr -= 1
            }
        }
        currentElement = document.querySelector(`[data-index="${serviceNr}"]`);
        currentElement.classList.add("active");
        currentElement = document.querySelector(`[data-value="${serviceNr}"]`);
        currentElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    }

    const closeModal = () => {
        // setError("")
        setSelectedService({})
        setOpen(false)
    }

    const openModal = (serviceCategory) => {
        setSelectedService({})
        setCurrentModal(serviceCategory);
        setOpen(true);
    }

    const handleNavigate = () => {
        if (selectedService && selectedService.serviceURL && currentStep === 2) {
            const serviceURL = selectedService.serviceURL;
            history.push({ pathname: `/servicenavigator/${serviceURL}`, newStandortUrl: standortUrl });
        }
    }

    const updateCurrentServices = async (service, serviceCatgory = '') => {
        if (shopBrand[standortUrl]['markenStandort']['data']['allCarMakes'] !== undefined) {
            dispatch(setServiceNavigatorNebenFabrikat(shopBrand[standortUrl]['markenStandort']['data']['allCarMakes']));
        } else {
            dispatch(setServiceNavigatorNebenFabrikat(shopBrand[standortUrl]['markenStandort']['data']['nebenFabrikat']));
            dispatch(setServiceNavigatorNebenFabrikat(nebenFabrikat => [...nebenFabrikat, hauptFabrikat]));
        }
        if (vehiclePreSelected === false) {
            dispatch(setServiceNavigatorCurrentService(serviceCatgory, service));

            if (Object.values(serviceCatgory.fahrzeuganabe).indexOf('HSN/TSN') > -1) {
                dispatch(setServiceNavigatorCurrentButton('hsn'));
            }
            else if (Object.values(serviceCatgory.fahrzeuganabe).indexOf('HSN/TSN') === -1 && Object.values(serviceCatgory.fahrzeuganabe).indexOf('FIN') > -1) {
                dispatch(setServiceNavigatorCurrentButton('fin'))
            } else if (Object.values(serviceCatgory.fahrzeuganabe).indexOf('Suchbaum') > -1) {
                dispatch(setServiceNavigatorCurrentButton('MANUELL'));
            }
            dispatch(setServiceNavigatorCurrentStep(2));
        } else {
            dispatch(setServiceNavigatorCurrentService(serviceCatgory, service));
            if (Object.values(serviceCatgory.fahrzeuganabe).indexOf('HSN/TSN') > -1) {
                dispatch(setServiceNavigatorCurrentButton('hsn'));
            }
            else if (Object.values(serviceCatgory.fahrzeuganabe).indexOf('HSN/TSN') === -1 && Object.values(serviceCatgory.fahrzeuganabe).indexOf('FIN') > -1) {
                dispatch(setServiceNavigatorCurrentButton('fin'));
            } else if (Object.values(serviceCatgory.fahrzeuganabe).indexOf('Suchbaum') > -1) {
                dispatch(setServiceNavigatorCurrentButton('MANUELL'));
            }
            dispatch(setServiceNavigatorCurrentStep(2));
        }
    }

    setTimeout(() => {
        if (currentStep === 2) {
            handleNavigate();
        }
    }, 1000);

    return (
        <>
            <Modal isOpen={open} onRequestClose={closeModal} contentLabel="Servicenavigator service list Modal">
                <div className="modal-header">
                    <div className='uk-flex uk-flex-between uk-flex-middle'>
                        <h2 style={{ marginBottom: "0" }}>{currentModal.serviceName}</h2><button style={{ border: "none", background: "none", }} type="button" onClick={closeModal}><span uk-icon="icon: close"></span></button>
                    </div>
                    <p>Bitte Service auswählen</p>
                </div>
                <div className="modal-body">
                    {currentModal?.services?.length > 0 && currentModal.services
                        .map((service) => {
                            return (
                                <div className="uk-margin" key={service._id}>
                                    <input type="radio" className="uk-radio uk-form-controls uk-margin-medium-right" name="radio" onClick={(e) => { setSelectedService(service) }}>
                                    </input>
                                    <label>
                                        {service.serviceTitle}
                                    </label>
                                    <br />
                                </div>
                            )

                        })}
                    {/* {error ? <div className="text-danger">{error}</div> : ""} */}
                    <button disabled={!selectedService._id} className={!selectedService._id ? 'uk-text-uppercase sn-button-disabled' : 'uk-text-uppercase sn-button-primary'} style={{ width: "100%", marginTop: "20px" }} onClick={() => updateCurrentServices(selectedService, currentModal)}>Weiter zu den Fahrzeugdetails</button>
                </div>
            </Modal>
            <div className="sn-servicelist">
                <button onClick={(e) => handleClick(e)} className='previous uk-hidden@s'><i className="fa fa-angle-left" /></button>
                <div className="uk-grid@m uk-grid-small uk-child-width-1-2@ uk-child-width-1-3@m sn-servicelist-items" data-uk-grid="">
                    {Services.length >= 1 && Services
                        .map((serviceCat, index) => {
                            return (
                                <div data-value={index} key={serviceCat._id}>
                                    <button className="uk-link-reset" onClick={() => openModal(serviceCat)} style={{ cursor: "pointer", border: "none", background: "none", width: "100%" }}>
                                        <div className="uk-card uk-card-small uk-text-center uk-card-default">
                                            <div className={serviceCat.image.includes("<svg") ? "uk-card-body uk-flex uk-flex-center uk-flex-middle sn-icons" : "uk-card-body uk-flex uk-flex-center sn-icons"} style={{ height: 150, "minWidth": "200px" }}>
                                                {serviceCat.image.includes("<svg") ?
                                                    <div dangerouslySetInnerHTML={{ __html: serviceCat.image }}></div>
                                                    :
                                                    // this part is only for the old categorys, where the image comes from ASW bucket. Same for the className of the parent div
                                                    <div style={{ backgroundColor: "var(--shop-main)", mask: `url(${serviceCat.image}) no-repeat center`, maskSize: "contain", WebkitMask: `url(${serviceCat.image}) no-repeat center`, WebkitMaskSize: "contain", width: "100%" }}></div>
                                                }
                                            </div>
                                            <div
                                                className="uk-card-footer uk-card-primary sn-button-primary uk-flex uk-flex-center uk-flex-middle serviceText"

                                            >
                                                <p>{serviceCat.serviceName}</p>
                                                <i className='fa fa-angle-down fa-lg uk-margin-small-left'></i>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            )
                        })}
                </div>
                <button onClick={(e) => handleClick(e)} className='next uk-hidden@s'><i className="fa fa-angle-right" /></button>
            </div>
        </>
    );
}

export default ServicenavigatorServicesList;